import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Card } from '@/components/sections/Card';
import { FunctionComponent } from 'react';

interface StandardisedProductsUserGuideProps {}

const StandardisedProductsUserGuide: FunctionComponent<StandardisedProductsUserGuideProps> = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Standardised Products User Guide',
      to: ''
    }
  ];

  return (
    <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title="Standardised Products User Guide" breadcrumbs={breadcrumbs} />
      <div className="px-6 py-8 h-full text-lg overflow-y-auto">
        <Card className="p-5 space-y-4">
          <div className="space-y-1">
            <div className="space-y-1">
              <p className="text-xl font-semibold">Build Your Standard:</p>
              <p>
                Select the ideal devices for your organisation from either our curated 'Basic - Better - Best' options
                or the comprehensive 'Full Catalogue.'
              </p>
              <p className="font-semibold">
                Remember that Basic - Better - Best is stock we hold for you to buy and comes with our advanced
                replacement warranty, and the Full Catalogue is stock owned by the customer.
              </p>
            </div>
            <div className="space-y-1">
              <p className="text-xl font-semibold">Why Standardise?</p>
              <p>
                Standardising your end-user hardware isn't just about simplifying your IT team's life - it's about
                boosting your entire business's efficiency and bottom line.
              </p>
              <p>
                <span className="font-semibold">Streamlined Support:</span> Fewer device types mean fewer issues to
                troubleshoot, faster resolutions, and happier employees.
              </p>
              <p>
                <span className="font-semibold">Enhanced Security:</span> A standardised environment is easier to
                secure, patch, and monitor, reducing your vulnerability to cyberattacks.
              </p>
            </div>
          </div>
          <div className="space-y-1">
            <div className="space-y-1">
              <p className="text-xl font-semibold">Full Catalogue Users:</p>
              <p>
                Don't forget to set your stock levels in the 'Stock Calculator' to ensure you have the devices you need,
                when you need them.
              </p>
            </div>
          </div>
          <div className="space-y-1">
            <p className="text-xl font-semibold">Manage Your Standard:</p>

            <p>
              You have the flexibility to add or remove products from your 'Standardised Products' list as your needs
              evolve.
            </p>

            <p>
              <span className="font-semibold">-Important:</span> Keep in mind that changes to your standardised products
              may impact any 'Bundles' (pre-configured groups of products) you've created. Be sure to review your
              'Bundles' after making any adjustments.
            </p>

            <div className="pt-2 space-y-1">
              <p>
                This is where you select the exact products your organization wants. You can choose from both the 'Full
                Catalogue' and 'Basic - Better - Best' models.
              </p>

              <p>
                Remember that if you are choosing from the 'Full Catalogue' you will need to configure your stock levels
                in the 'Stock Calculator' section.
              </p>

              <p>
                You can add and remove items from your 'Standardised Products' at any time but be mindful if you have
                any 'Bundles' with a product you have removed, it will make the bundle un-orderable and you will need to
                adjust your bundle.
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default StandardisedProductsUserGuide;
